/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestStartedNotificationActionData } from './FanRemixContestStartedNotificationActionData';
import {
    FanRemixContestStartedNotificationActionDataFromJSON,
    FanRemixContestStartedNotificationActionDataFromJSONTyped,
    FanRemixContestStartedNotificationActionDataToJSON,
} from './FanRemixContestStartedNotificationActionData';

/**
 * 
 * @export
 * @interface FanRemixContestStartedNotificationAction
 */
export interface FanRemixContestStartedNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestStartedNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestStartedNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestStartedNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {FanRemixContestStartedNotificationActionData}
     * @memberof FanRemixContestStartedNotificationAction
     */
    data: FanRemixContestStartedNotificationActionData;
}

/**
 * Check if a given object implements the FanRemixContestStartedNotificationAction interface.
 */
export function instanceOfFanRemixContestStartedNotificationAction(value: object): value is FanRemixContestStartedNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function FanRemixContestStartedNotificationActionFromJSON(json: any): FanRemixContestStartedNotificationAction {
    return FanRemixContestStartedNotificationActionFromJSONTyped(json, false);
}

export function FanRemixContestStartedNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestStartedNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': FanRemixContestStartedNotificationActionDataFromJSON(json['data']),
    };
}

export function FanRemixContestStartedNotificationActionToJSON(value?: FanRemixContestStartedNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': FanRemixContestStartedNotificationActionDataToJSON(value.data),
    };
}

